import classnames from 'classnames';

import styles from '../conversationDetails.module.scss';

type TypingIndicatorProps = {
  isTyping: boolean;
};

export const TypingIndicator = ({
  isTyping,
}: TypingIndicatorProps): JSX.Element => {
  return (
    <div
      className={classnames({
        [styles.typingOverlay]: true,
        [styles.typingOverlayTyping]: isTyping,
      })}
    >
      {isTyping && (
        <>
          {/* 3 divs animated by CSS */}
          <div className={styles.typingSpinnerItem}></div>
          <div className={styles.typingSpinnerItem}></div>
          <div className={styles.typingSpinnerItem}></div>
        </>
      )}
    </div>
  );
};
